// Get Branch Actions
export const getBranchRequest = (page: number, size: number, search: string) => ({
    type: 'GET_BRANCH_REQUEST',
    payload: { page, size, search },
  });
  
  export const getBranchSuccess = (data: any) => ({
    type: 'GET_BRANCH_SUCCESS',
    payload: { data },
  });
  
  export const getBranchFailure = (error: string) => ({
    type: 'GET_BRANCH_FAILURE',
    payload: { error },
  });
  
  export const resetGetBranch = () => ({
    type: 'RESET_GET_BRANCH',
  });
  
  // Create Branch Actions
  export const createBranchRequest = (data: any) => ({
    type: 'CREATE_BRANCH_REQUEST',
    payload: data,
  });
  
  export const createBranchSuccess = (data: any) => ({
    type: 'CREATE_BRANCH_SUCCESS',
    payload: { data },
  });
  
  export const createBranchFailure = (error: string) => ({
    type: 'CREATE_BRANCH_FAILURE',
    payload: { error },
  });
  
  export const resetCreateBranch = () => ({
    type: 'RESET_CREATE_BRANCH',
  });
  
  // Update Branch Actions
  export const updateBranchRequest = (id: string, data: any) => ({
    type: 'UPDATE_BRANCH_REQUEST',
    payload: { id, data },
  });
  
  export const updateBranchSuccess = (data: any) => ({
    type: 'UPDATE_BRANCH_SUCCESS',
    payload: { data },
  });
  
  export const updateBranchFailure = (error: string) => ({
    type: 'UPDATE_BRANCH_FAILURE',
    payload: { error },
  });
  
  export const resetUpdateBranch = () => ({
    type: 'RESET_UPDATE_BRANCH',
  });
  
  // Delete Branch Actions
  export const deleteBranchRequest = (id: string) => ({
    type: 'DELETE_BRANCH_REQUEST',
    payload: { id },
  });
  
  export const deleteBranchSuccess = (data: any) => ({
    type: 'DELETE_BRANCH_SUCCESS',
    payload: { data },
  });
  
  export const deleteBranchFailure = (error: string) => ({
    type: 'DELETE_BRANCH_FAILURE',
    payload: { error },
  });
  
  export const resetDeleteBranch = () => ({
    type: 'RESET_DELETE_BRANCH',
  });